// ==========================
// Version 1 — src/polyfills.js
// - Ensures Buffer & process exist in the browser
// - Sets window.global for libs that expect Node-style global
// ==========================
import { Buffer } from "buffer";
import process from "process";

if (typeof window !== "undefined") {
  if (!window.global) window.global = window;
  if (!window.Buffer) window.Buffer = Buffer;
  if (!window.process) window.process = process;
}
// ==========================
// End Version 1 — src/polyfills.js
// ==========================
